import { FilterSelectionMode, IslandFilterGroup } from '../filterTypes'
import { MemoryFilter } from './types'

export const incentivizedIslandsFilter: MemoryFilter = {
  displayName: 'Incentivized',
  isActive: false,
  group: IslandFilterGroup.Incentivized,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 0,
  // filterFunction: (island: SubgraphIsland | IslandApiResponse, params: any) =>
  //   SWEETENED_ISLANDS[params.chainId].includes(island.id),
}

export const volatileIslandsFilter: MemoryFilter = {
  displayName: 'Volatile',
  isActive: false,
  group: IslandFilterGroup.IslandType,
  selectionMode: FilterSelectionMode.SINGLE, // Mutually exclusive with Stable
  priority: 1,
  // filterFunction: (island: SubgraphIsland | IslandApiResponse, params: any) =>
  //   VOLATILE_ISLANDS[params.chainId].includes(island.id),
}

export const stableIslandsFilter: MemoryFilter = {
  displayName: 'Stable',
  isActive: false,
  group: IslandFilterGroup.IslandType,
  selectionMode: FilterSelectionMode.SINGLE, // Mutually exclusive with Volatile
  priority: 2,
  // filterFunction: (island: SubgraphIsland | IslandApiResponse, params: any) =>
  //   !VOLATILE_ISLANDS[params.chainId].includes(island.id),
}

export const lowTvlIslandsFilter: MemoryFilter = {
  displayName: 'Hide Low TVL',
  isActive: true,
  group: IslandFilterGroup.LowTvl,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 3,
}

export const managerFilter: MemoryFilter = {
  displayName: 'Auto-PoL',
  isActive: false,
  group: IslandFilterGroup.Manager,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 4,
}

export const baultFilter: MemoryFilter = {
  displayName: 'Baults',
  isActive: false,
  group: IslandFilterGroup.Baults,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 5,
}

export const managedFilter: MemoryFilter = {
  displayName: 'Managed',
  isActive: false,
  group: IslandFilterGroup.Managed,
  selectionMode: FilterSelectionMode.SINGLE,
  priority: 6,
}

export const permissionlessFilter: MemoryFilter = {
  displayName: 'Permissionless',
  isActive: false,
  group: IslandFilterGroup.Managed,
  selectionMode: FilterSelectionMode.SINGLE,
  priority: 7,
}

export const allFilters = [
  incentivizedIslandsFilter,
  volatileIslandsFilter,
  stableIslandsFilter,
  lowTvlIslandsFilter,
  managerFilter,
  baultFilter,
  managedFilter,
  permissionlessFilter,
]

export const filterRegistry = allFilters.reduce((acc, filter) => {
  acc[filter.displayName] = filter
  return acc
}, {} as Record<string, MemoryFilter>)

export const filterWithoutFunction = (filter: MemoryFilter) => ({
  ...filter,
  filterFunction: undefined,
})

export const allFiltersWithoutFunction = allFilters.map(filterWithoutFunction)
